"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_confirm-modal.scss");

function ConfirmationModal(a) {
  var b = a.visible,
      c = a.onClose,
      d = a.onSave,
      e = a.title,
      f = a.subtitle,
      g = a.saveBtnText,
      h = a.className,
      i = a.children;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("confirm-modal", h)
  }, _react["default"].createElement(_uiKit.FormModal, {
    visible: b,
    onClose: c,
    title: e,
    subtitle: f,
    hideFooter: !0
  }, i, _react["default"].createElement(_uiKit.Button, {
    className: "confirm-modal__btn",
    onClick: d
  }, g), _react["default"].createElement(_uiKit.Button, {
    type: "TERTIARY",
    className: "confirm-modal__cancel-btn",
    onClick: c
  }, "Cancel")));
}

ConfirmationModal.defaultProps = {
  saveBtnText: "Ok"
};

var _default = (0, _react.memo)(ConfirmationModal);

exports["default"] = _default;